/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './verifyPhone.defs'
export { main as default } from './verifyPhone.defs'
